// ** React Imports
import { useState } from "react";

// ** Third Party Components
import { toast } from "helpers/toastWrapper";
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import Tooltip from "components/layout/Tooltip";
import { ButtonText } from "components/layout/Button/ButtonText";

// ** Utils & Helpers
import api from "helpers/ApiClient";

// ** Hooks
import { useBlockResendEmail } from "../containers/Register/hooks/useBlockResendEmail";
// #####################################################

const SendRegistrationEmailButton = ({ email, remainingTime, isModal }) => {
	const { t } = useTranslation("landing");

	const [initialTimeResend, setInitialTimeResend] = useState(
		new Date(new Date().getTime() - remainingTime * 1000).getTime()
	);
	const [isSending, setIsSending] = useState(false);

	const { isResendDisabledByTime, remainingTimeString, remainingTimeNumber } =
		useBlockResendEmail({ initialTime: initialTimeResend });

	const sendEmail = () => {
		setIsSending(true);
		api.post("/authorization/registration/web/send", {
			id: null,
			email,
		})
			.then(({ data } = {}) => {
				if (!data) {
					setInitialTimeResend(new Date().getTime());
				} else {
					setInitialTimeResend(new Date(data?.send).getTime());
				}
				toast.success(t("landing:register.email.resendSuccessText"));
			})
			.catch((error) => {
				if (error?.response?.data?.error) {
					toast.error(`${error.response.data.error}`);
				}
			})
			.finally(() => {
				setIsSending(false);
			});
	};

	// #####################################################

	return (
		<Block flex my={4} justifyCenter style={{ gap: "0.5rem" }}>
			<Block>
				<Text size="0.9rem">
					{t("landing:register.email.resendText")}
				</Text>
			</Block>
			<Tooltip
				text={
					isResendDisabledByTime &&
					remainingTimeString &&
					remainingTimeNumber > 0 &&
					`${t(
						"landing:register.email.resendTooltipText"
					)} ${remainingTimeString}`
				}
			>
				<ButtonText
					isLanding
					onClick={() => {
						if (!isResendDisabledByTime && !isSending) {
							sendEmail();
						}
					}}
					disabled={isResendDisabledByTime || isSending}
					$isModal={isModal}
				>
					{t("landing:register.email:resendLink")}
				</ButtonText>
			</Tooltip>
		</Block>
	);
};

export default SendRegistrationEmailButton;
